import { render } from "./TelehealthWrapper.vue?vue&type=template&id=2bd089db&scoped=true&ts=true"
import script from "./TelehealthWrapper.vue?vue&type=script&lang=ts"
export * from "./TelehealthWrapper.vue?vue&type=script&lang=ts"

import "./TelehealthWrapper.vue?vue&type=style&index=0&id=2bd089db&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd089db"]])

export default __exports__